import { sva } from "@filadd/phi-plus-styled-system/css";
export const sideNavLayoutRecipe = sva({
    slots: [
        "container",
        "contentContainer",
        "contentWrapper",
        "desktopSidenavWrapper",
    ],
    base: {
        container: {
            minHeight: "fullVH",
            display: "flex",
            flexDir: "column",
            bgColor: "neutral.100",
        },
        contentContainer: {
            flexGrow: 1,
            width: "full",
            px: 4,
            transition: "all 0.5s ease",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        contentWrapper: {
            flexGrow: 1,
            width: "full",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.5s ease",
        },
        desktopSidenavWrapper: {
            zIndex: "overlay",
            position: "fixed",
            hideBelow: "md",
        },
    },
    variants: {
        expanded: {
            true: {},
            false: {
                // collapsed sidebar in desktop looks the same independent of fixed
                contentContainer: {
                    md: {
                        p: "0 0 0 token(sizes.navbarCollapsedWidth)",
                    },
                },
            },
        },
        fixed: {
            true: {
                // when fixed, the sidebar always "occupies" the same width, independent of expand
                contentContainer: {
                    md: {
                        p: "0 0 0 calc(token(sizes.navbarCollapsedWidth) + token(sizes.2))",
                    },
                },
            },
            false: {},
        },
    },
    compoundVariants: [
        // collapsed sidebar in desktop for not fixed adds some margins
        {
            expanded: false,
            fixed: false,
            css: {
                contentWrapper: {
                    md: {
                        width: "85%",
                    },
                },
            },
        },
        // expanded sidebar in desktop for not fixed pushes content to the right
        {
            expanded: true,
            fixed: false,
            css: {
                contentContainer: {
                    md: {
                        p: "0 token(sizes.6) 0 calc(token(sizes.navbarExpandedWidth) + token(sizes.6))",
                    },
                },
            },
        },
    ],
});
//# sourceMappingURL=sideNavLayoutRecipe.js.map